import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/notifications',
  component: Management,
  redirect: '/notifications/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/notifications/List'),
      redirect: 'list/message',
      meta: {
        auth: Auth.listNotifications
      },
      children: [
        {
          path: 'message',
          component: () => import('@/views/notifications/ListTable'),
          meta: {
            auth: Auth.listNotifications,
            tabName: 'message'
          }
        },
        {
          path: 'reminder',
          component: () => import('@/views/notifications/ListTable'),
          meta: {
            auth: Auth.listNotifications,
            tabName: 'reminder'
          }
        },
        {
          path: 'announce',
          component: () => import('@/views/notifications/ListTable'),
          meta: {
            auth: Auth.listNotifications,
            tabName: 'announce'
          }
        }
      ]
    },
    // 发送消息通知
    {
      path: 'send_message',
      component: () => import('@/views/notifications/SendMessage'),
      meta: {
        auth: Auth.listNotifications
      }
    },
    // 用户查询发送消息
    {
      path: 'send_announce',
      component: () => import('@/views/notifications/SendAnnounce'),
      meta: {
        auth: Auth.listNotifications
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/notifications/DetailLayout'),
      meta: {
        auth: Auth.showMessage
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/notifications/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showMessage
          }
        }
      ]
    }
  ]
}
